import React from 'react';
import { Button } from 'react-bootstrap';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import Skeleton from 'react-loading-skeleton';

const Pagination = ({ currentPage, totalPages, onNext, onPrevious, loading }) => {
    console.log("Total pages", totalPages)
     if (!totalPages || totalPages <= 1) {
        return null; // Don't render pagination if totalPages is null, 0, or 1
    }
    return (
        <div className='d-flex gap-3 align-items-center'>
            {loading ? (
                <Skeleton className='mb-2' width={70} height={25} />
            ) : (
                (totalPages !== 0 || totalPages !== 1 || totalPages !== null) && (
                    <p className='mb-0 small'>{`${currentPage} of ${totalPages || 0}`}</p>
                )
            )}
            <Button
                className='btn-custom rounded-3 small p-1 px-2'
                onClick={onPrevious}
                disabled={currentPage === 1}
            >
                <FaAngleLeft />
            </Button>
            <Button
                className='btn-custom rounded-3 small p-1 px-2'
                onClick={onNext}
                disabled={currentPage === totalPages}
            >
                <FaAngleRight />
            </Button>
        </div>
    );
};

export default Pagination;
